// extracted by mini-css-extract-plugin
export var marginNegative = "_6m-5 _6m-3 _6m-1";
export var marginPositive = "_6m-4 _6m-3 _6m-1";
export var modalContent = "_6m-6";
export var samplesTable = "_6m-8";
export var samplesTableContainer = "_6m-7";
export var statBox = "_6m-a";
export var tableCell = "_6m-1";
export var tableCellCenter = "_6m-2 _6m-1";
export var tableCellRight = "_6m-3 _6m-1";
export var tableHeader = "_6m-0";
export var trackingNumber = "_6m-9";